'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// {
//   MenuConfig.map((col, colI) => {
//     return <Col xs={12} sm={12} md={3} lg={3}
//       key={'menu-col-'+colI}
//       styleName='menu-column'
//     >
//       {
//         col.map((item, itemI)=>{
//           return <div
//             key={'menu-item-'+itemI}
//             styleName={'menu-link-'+item[2]}
//           >
//             <Link
//               to={item[0]}
//               title={item[1]}
//             >
//               {
//                 item[3] ?
//                   <span>
//                     <LinkIcon
//                       nospace
//                       faclass={'fa-'+item[3]}
//                     />
//                     &nbsp;
//                   </span> :
//                   null
//               }{item[1]}
//               {
//                 item[4] ?
//                   <span styleName='menu-subtitle'>
//                     {item[4]}
//                   </span> :
//                   null
//               }
//             </Link>
//           </div>
//         })
//       }

var MenuConfig = [[[_config2.default.routes.home, 'Home', 'l'], [_config2.default.routes.about, 'About us', 'l'], [_config2.default.routes.howitworks, 'How it works', 's'], [_config2.default.routes.videoTutorials, 'Video tutorials', 's'], [_config2.default.routes.resources, 'Resources', 's'], [_config2.default.routes.fossilFuelCompanies, 'Fossil fuel companies', 'l'], [_config2.default.routes.carbonunderground200, 'Carbon reserve owners', 's', null, 'Carbon Underground 200™'], [_config2.default.routes.macroclimate50, 'Coal-fired utilities', 's', null, 'Macroclimate® 50'],
// [
//   config.routes.morningstar,
//   'Morningstar®',
//   's',
//   null,
//   'Fossil fuel industries'
// ],
[_config2.default.routes.banksInsurance, 'Fossil fuel finance & insurance', 's'], [_config2.default.routes.clean200, 'Clean200™', 's']], [[_config2.default.routes.clean, 'Search funds', 'l', 'search'], [_config2.default.routes.indexfunds, 'Index funds', 's'], [_config2.default.routes.targetdate, 'Target date funds', 's'], [_config2.default.routes.families, 'Fund managers', 'l'], [_config2.default.routes.families + '?q=Vanguard', 'Vanguard', 's'], [_config2.default.routes.families + '?q=BlackRock%2FiShares', 'BlackRock/iShares', 's'], [_config2.default.routes.families + '?q=State%20Street', 'State Street', 's'], [_config2.default.routes.tspLanding, 'Thrift Savings Plan', 's'], [_config2.default.routes.families, 'More fund managers', 's']], [[_config2.default.links.blog, 'Blog', 'l'], [_config2.default.routes.toolkit, 'Fossil free action toolkit', 'l'], [_config2.default.links.signup, 'Sign up', 'l', 'envelope-o'], [_config2.default.links.donate, 'Donate to As You Sow', 'l', 'heart'], [_config2.default.routes.media, 'Media', 's'], [_config2.default.links.contact, 'Contact us', 's'], [_config2.default.routes.legal, 'Legal disclaimer', 's']]];

exports.default = MenuConfig;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MenuConfig/MenuConfig.js
// module id = 1384
// module chunks = 0